import { com } from '@eidu/form'
import { useContext, useEffect, useState } from 'react'
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce'
import EntityWithLabelAndRelated from '../domain/entity/EntityWithLabelAndRelated'
import useEntityRepository from './useEntityRepository'
import { setGlobalAuthContext } from './EntityRepository'
import { EntityTypesContext } from './context/EntityTypes'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityType = com.eidu.sharedlib.entity.type.EntityType

type UseEntityByIdResult = { entity: EntityWithLabelAndRelated | null | undefined; loading: boolean }

const useEntityById = (id: EntityId | undefined): UseEntityByIdResult => {
  const authContext = useContext<IAuthContext>(AuthContext)
  useEffect(() => {
    setGlobalAuthContext(authContext)
  }, [authContext])

  const entityTypesRepo = useContext(EntityTypesContext)
  const types = entityTypesRepo.useAll() || new Map<EntityTypeId, EntityType>()

  const repo = useEntityRepository({ typeId: undefined, types, pageSize: 1 }, [
    JSON.stringify([...types.keys()].map((it) => it.toString())),
  ])

  const [value, setValue] = useState<EntityWithLabelAndRelated | null | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    let cancelled = false
    if (!id) {
      setValue(undefined)
      setLoading(false)
    } else {
      setLoading(true)
      repo
        .get(id)
        .then((it) => {
          if (!cancelled) setValue(it)
        })
        .catch(() => {
          if (!cancelled) setValue(null)
        })
        .finally(() => {
          if (!cancelled) setLoading(false)
        })
    }
    return () => {
      cancelled = true
    }
  }, [repo, id?.toString()])

  return { entity: value, loading }
}

export default useEntityById
